/* eslint-disable import/order */
// deps
import React, { useCallback, useContext, useMemo, useState } from "react";

// internal deps
import { getCloudinaryUrl } from "@swiggy-private/js-utils";
import { AnalyticsEventContext, SwiggyHeadersContext } from "@swiggy-private/swiggy-money-context/src";
import GiftCardRedemption from "@swiggy-private/swiggy-money-ui/src/GiftCardRedemption";

// analytics
import { getAnalyticsEvents } from "analytics";
import { getGiftCardAnalyticsEvents } from "analytics/giftcard";

// utils

// hooks
import { useLogin } from "hooks/useLogin";
import type { NextPage } from "next";
import Head from "next/head";

// styles
import { Container, Main } from "styles/home";
import { getBridgeSdk } from "utils/bridgeSdk";

// constants
import { getCurrentGiftingCardConfig } from "utils/utils";

const GiftRedemption: NextPage = () => {
    const [playLottie, setPlayLottie] = useState(false);
    const { swiggyHeaders, dynamicFlags } = useContext(SwiggyHeadersContext);
    const analyticsEvents = useMemo(
        () => getAnalyticsEvents(swiggyHeaders, dynamicFlags),
        [swiggyHeaders, dynamicFlags],
    );
    const analyticsContextValue = useMemo(() => getGiftCardAnalyticsEvents(analyticsEvents), [analyticsEvents]);

    useLogin(setPlayLottie);

    const cardConfig = getCurrentGiftingCardConfig();

    const handleLottieClose = useCallback(() => {
        getBridgeSdk()
            .close()
            .catch(() => void 0);
    }, []);

    return (
        <Container>
            <Head>
                <link rel="preconnect" href="//analytics.swiggy.com" crossOrigin="anonymous" />
                <link rel="dns-prefetch" href="//analytics.swiggy.com" />
                <link rel="preconnect" href={process.env.NEXT_PUBLIC_CDN_URL} crossOrigin="anonymous" />
                <link rel="dns-prefetch" href={process.env.NEXT_PUBLIC_CDN_URL} />
                <title>Redeem your gift</title>
                <meta name="description" content="Swiggy gift cards" />
                <meta
                    name="viewport"
                    content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover"
                />
                <meta property="og:image" content={getCloudinaryUrl(cardConfig.mainImageUrl)} />
                <link rel="icon" href="data:;base64,iVBORw0KGgo=" />
            </Head>
            <Main>
                <AnalyticsEventContext.Provider value={analyticsContextValue}>
                    <GiftCardRedemption onLottieClose={handleLottieClose} playLottie={playLottie} />
                </AnalyticsEventContext.Provider>
            </Main>
        </Container>
    );
};

export default GiftRedemption;
